import React, { Component } from "react";

// import html2canvas from "html2canvas";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "../../Actions/Dashboard";
import * as sessionActions from "../../Actions/Session";
import * as modalActions from "../../Actions/Modal";

import GenerateComponent from "./../componentes/GenerateInformComponent";
import InformGenerated from "./../componentes/InformGenerated"; 

import { initMap } from "./../componentes/mapInform";

import { sendService, answerOk } from "../../Services/service";

import "./../generateInform.css";

// /* global jsPDF */

class GenerateInformContainer extends Component {
  state = {
    generated: false,
    error: null,
    dateRange0: null,
    data: {},
    form: {},
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
    if (event.target.name === "time" && event.target.value === 1) {
      this.setState({ showRange: true });
    } else {
      this.setState({ showRange: false });
    }
  };

  handlerSave = async () => {
    if (this.state.dateRange0 === null || this.state.dateRange0 === "") {
      this.setState({ error: "* Seleccione una fecha" });
      return;
    }
    this.props.modalActions.openLoader();
    var res = await sendService("/api/v1/informs/dayly", "POST", {
      day: this.state.dateRange0 + "T00:00:00.000Z",
    });
    if (!answerOk(res, this.props.sessionAction.closeSession)) return;
    this.props.modalActions.closeLoader();
    this.setState({ error: null, generated: true, data: res.response });
  };

  handlerChangeDate = (event) => {
    this.setState({ [event.target.id]: event.target.value, error: null });
  };

  handlerCancel = () => {
    this.props.actions.activePage("/");
    this.props.history.push("/");
  };

  async componentDidMount() {
    // const url = '/api/v1/informs/weekly/' + this.state.dateRange0 + '/' + this.state.dateRange1 + '/' + this.state.time
    const url = "/api/v1/informs/weekly/1607749200000/1608267600000/0";
    this.props.modalActions.openLoader();
    const resp = await sendService(url, "POST");
    this.props.modalActions.closeLoader();
    if (
      !answerOk(resp, () => {
        this.props.sessionActions.closeSession();
        this.props.modalActions.openLoader();
      })
    )
      return;
    this.setState({ data: resp.response, generated: true });
    console.log(resp);
  }

  componentDidUpdate() {
    setTimeout(() => {
      if (this.state.generated) {
        initMap({
          id: "yearMap",
          data: this.state.data.locationYear,
          type: "heat",
          zoom: 6,
        });
        initMap({
          id: "monthMap",
          data: this.state.data.locationMonth,
          type: "heat",
          zoom: 6,
        });
      }
    }, 500);
  }

  savePdf = async () => {
    // let pages = document.getElementsByClassName("work-sheet-city-card");
    // var pdf = new jsPDF("p", "px", [1000, 1415]);
    // for (var i = 0; i < pages.length; i++) {
    //   await new Promise(function (resolve) {
    //     html2canvas(pages[i], { scale: 1, useCORS: true }).then(function (canvas) {
    //       var img = canvas.toDataURL("image/png");
    //       pdf.addImage(img, "JPEG", 0, 0, 1000, 1415);
    //       if (i + 1 === pages.length) {
    //         pdf.save("infomre.pdf");
    //       } else {
    //         pdf.addPage();
    //       }
    //       resolve();
    //     });
    //   });
    // }
  };

  cancelInform = () => {
    this.setState({ generated: false });
  };
  render() {
    return (
      <>
        {!this.state.generated ? (
          <GenerateComponent
            onSelect={this.handleChange}
            onChangeDate={this.handlerChangeDate}
            onSave={this.handlerSave}
            onCancel={this.handlerCancel}
            state={this.state}
            showRange={this.state.showRange}
          />
        ) : (
          <InformGenerated
            onSave={this.savePdf}
            onCancel={this.cancelInform}
            data={this.state.data}
            result={this.props.result}

          />
        )}
      </>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
    sessionAction: bindActionCreators(sessionActions, dispatch),
    modalActions: bindActionCreators(modalActions, dispatch),
  };
}

function mapStateToProps(state) {
  return {
    ...state,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GenerateInformContainer);
